function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.50008 5.33328C9.8537 5.33328 10.1928 5.47376 10.4429 5.72381C10.6929 5.97386 10.8334 6.31299 10.8334 6.66662V13.3333C10.8334 14.0666 10.2334 14.6666 9.50008 14.6666H1.50008C1.14646 14.6666 0.807321 14.5261 0.557272 14.2761C0.307224 14.026 0.166748 13.6869 0.166748 13.3333V6.66662C0.166748 5.92662 0.760081 5.33328 1.50008 5.33328H2.16675V3.99995C2.16675 2.15995 3.66008 0.665283 5.50008 0.665283C7.34008 0.665283 8.83341 2.15995 8.83341 3.99995V5.33328H9.50008ZM5.50008 1.99995C4.39341 1.99995 3.50008 2.89328 3.50008 3.99995V5.33328H7.50008V3.99995C7.50008 2.89328 6.60675 1.99995 5.50008 1.99995ZM4.83341 12.6666L9.00008 8.50662L8.06008 7.56662L4.83341 10.7866L3.10675 9.06662L2.16675 9.99995L4.83341 12.6666Z",
  fill: "currentColor",
  fillOpacity: 0.5
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c1f6cb2f.svg";
export { ForwardRef as ReactComponent };